<template>
  <div class="bg-sub">
    <div class="container header-page">
      <mdb-card class="card-profile">
        <mdb-card-body class="card-body-profile">
          <div class="header-profile">
            <h2 class="text-center">ลบข้อมูลผู้ใช้งาน</h2>

            <div class="form-profile">
              <!--span class="is-success">{{alertUpdate}}</span-->
              <div v-if="alertUpdate" class="alert alert-success alert-dismissible fade show" role="alert">
                <span class="text-alert">ส่งคำขอลบข้อมูลผู้ใช้งานเรียบร้อยแล้ว !</span>
              <button type="button" @click="alertUpdate=false" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              </div>

              <div class="text-box">
                <label class="text-label">เหตุผลขอลบข้อมูลผู้ใช้งาน</label>
                <textarea row="4" type="text" class="form-control" name="email" v-model="account.remove" placeholder="ระบุเหตุผล" label="ระบุเหตุผล"/>
              </div>


              

            <div class="text-center footer-card-profile">
              <btn class="btn-update-account" color="primary" @click="Update()" :disabled="errors.any()">ยืนยันการลบ</btn>
            </div>
          </div>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import { mdbCarousel, mdbCarouselItem, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbInput, Btn, mdbCol, mdbRow } from 'mdbvue';

export default {
  name: 'RemovePage',
  components: {
    mdbCarousel,
    mdbCarouselItem,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Btn,
    mdbInput,
    config,
    mdbRow,
    mdbCol
  },
  data() {
    return {
      account: {},
      alertUpdate: false,
      ShowUser: ''
    };
  },
  mounted() {
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    Account() {
      let APIgetAccount = Host + '/api/v1/member/account';
      axios.post(APIgetAccount , {
        email: localStorage.emailfront
      }).then(response => {
        this.account = response.data.result;
        //console.log(this.account);
      });
    },
    Update() {
      let APIgetUpdate = Host + '/api/v1/member/update';
      var data = {
        remove: this.account.remove,
      };
      axios.post(APIgetUpdate , data).then(response => {
        this.alertUpdate = true;
        setTimeout(function () {
          location.reload();
        }, 3000);
      });
    }
  }
};
</script>

<style>
</style>
